module.exports = __webpack_public_path__ + "img/14.dd869009.webp";